import { render, staticRenderFns } from "./ServerSettingsComponent.vue?vue&type=template&id=3aa10dde&scoped=true&"
import script from "./ServerSettingsComponent.vue?vue&type=script&lang=js&"
export * from "./ServerSettingsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ServerSettingsComponent.vue?vue&type=style&index=0&id=3aa10dde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa10dde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
